export enum CalendarView {
  ALL_SUBJECTS = 'All Subjects'
  // MY_SCHEDULE = 'My Schedule'
}
